import styled, { css } from 'styled-components'

export const Container = styled.div`
  border: 1px solid #cfcfcf;

  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => `rgba(${theme.grayscale.neutral}, 0.5)`};

  border-radius: 4px;
`

export const Content = styled.div`
  padding: 16px 30px 0 8px;

  @media only screen and (min-width: 800px) {
    padding: 24px 0 0 72px;
  }
`

const desktopRowHeight = 86

export const RowsContainer = styled.div`
  @media only screen and (min-width: 800px) {
    max-height: ${desktopRowHeight * 5}px;
    overflow-y: scroll;

    ::-webkit-scrollbar {
      width: 57px;
    }

    ::-webkit-scrollbar-thumb {
      border: 25px solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
      background-color: ${({ theme }) => `rgba(${theme.grayscale.neutral}, 0.4)`};

      &:hover {
        background-color: ${({ theme }) => `rgba(${theme.grayscale.neutral}, 0.6)`};
      }
    }
  }
`

export const ExpandableRows = styled.div<{ fullHeight: number; isExpanded: boolean }>`
  max-height: 0;

  transition: max-height 0.3s ease-in-out;

  overflow: hidden;

  ${({ isExpanded, fullHeight }) =>
    isExpanded &&
    css`
      max-height: ${fullHeight}px;
    `}

  @media only screen and (min-width: 800px) {
    max-height: unset;
  }
`

export const Row = styled.div`
  display: flex;
  justify-content: flex-start;

  padding-bottom: 20px;

  p {
    margin: 0;
  }

  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

  .column-1 {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: space-between;

    margin-right: 24px;

    .number {
      font-size: 0.875rem;
      font-weight: 500;

      width: 15px;
      text-align: center;
    }

    .arrow-up,
    .arrow-down {
      width: 20px;
      height: 20px;
    }

    .arrow-up {
      color: ${({ theme }) => `rgb(${theme.green[500]})`};
    }

    .arrow-down {
      color: ${({ theme }) => `rgb(${theme.red.base})`};
    }
  }

  .column-2 {
    display: flex;
    flex-direction: column;
    gap: 12px;

    flex-grow: 1;

    margin-right: 8px;

    .label {
      font-size: 0.75rem;
      font-weight: 700;
      line-height: 0.9rem;
    }
  }

  .column-3 {
    display: flex;
    align-items: flex-end;

    .text {
      font-size: 0.75rem;
      font-weight: 700;
      line-height: 0.9rem;

      width: 37px;
      text-align: center;
    }
  }

  @media only screen and (min-width: 800px) {
    padding-bottom: 24px;

    .column-1 {
      gap: 16px;

      margin-right: 44px;

      .number {
        font-size: 1.625rem;
      }

      .arrow {
        width: 16px;
        height: 8px;
      }

      .arrow-up,
      .arrow-down {
        width: 32px;
        height: 32px;
      }
    }

    .column-2 {
      gap: 24px;
      margin-right: 24px;

      .label {
        font-size: 1.25rem;
        line-height: 1.5rem;
      }
    }

    .column-3 {
      .text {
        font-size: 1.25rem;
        width: 62px;
      }
    }
  }
`

export const ProgressBar = styled.div<{ progress: number }>`
  height: 8px;

  border-radius: 8px;

  background-color: ${({ theme }) => `rgb(${theme.grayscale[400]})`};

  position: relative;

  &::before {
    content: '';
    display: block;

    border-radius: 8px;

    width: ${({ progress }) => progress}%;
    height: 100%;

    background-color: #2b5cf3;

    animation: grow 1s ease-out;
  }

  @media only screen and (min-width: 800px) {
    height: 14px;
  }

  @keyframes grow {
    0% {
      width: 0;
    }
  }
`

export const SeeMore = styled.button<{ isExpanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  width: 100%;

  background: none;
  border: 0;
  margin: 0;
  padding: 8px 0 12px 0;

  color: ${({ theme }) => `rgb(${theme.primary.base})`};

  font-size: 0.75rem;
  font-weight: 700;

  .arrow {
    width: 18px;
    height: 18px;

    transition: transform 0.3s ease;
  }

  ${({ isExpanded }) =>
    isExpanded &&
    css`
      .arrow {
        transform: rotate(180deg);
      }
    `}
`
